<template>
    <div v-if="info">
        <Down v-if="isWeixins()" />
        <div :class="{'daily-list-panel':true,'iswx':isWeixins()}">
            <div v-if="$route.query.h" class="tab-test" :style="{'width': '100%','height': $route.query.h /100 + 'rem'}"></div>
            <div :class="{'daily-pro':true,'intelligence':true}">
                <Header :behavior="behavior" :type="type" :info="info" :buy_info="buy_info" />
            </div>
            <!-- {/* 情报模型tab切换 */} -->
            <template v-if="inteDown">
                <div :class="{'intelligence-tab':true}">
                    <div class="recommend-total">推荐总数：{{inteRecommendTotal}}条 {{inteRecommendTime ? (inteRecommendTime+'更新') : ''}}</div>
                    <div v-show="info.status == 2 || info.status == 1" class="qbsdnoVipBox">
                        <div class="qbsdnoVip">
                            <img src='https://img0.jihai8.com/jhimg/5e6ac1b39476fdce050f1d4f968c9a1a.png' />
                            <div class="word">
                                <p><em>{{inteRecommendTotalCurrent}}</em>条重要核心情报 开通即可查看全部</p>
                                <span @click="go_daily_buy(type, false)">立即解锁></span>
                            </div>
                        </div>
                    </div>
                    <div class="screen-parent clearfloat">
                        <div class="match-state">
                            <span class="tab-name">主客</span>
                            <span class="inte-state" ref="intestateshow" @click="showIntHomeAwayWindow">{{inteHomeAwayStateText}}<i class="triangle fl-r"></i></span>
                            <!-- {/* 时间切换弹窗 */} -->
                            <div class="month-drop" ref="inteHomeAwaywindow">
                                <ul class="intestateul intestateulzk" ref="inteHomeAwaylist" @click="changeInteHomeAway">
                                    <li :class="{'active': inteMatchStateText == '全部'}" data-value="-1" data-key="全部">全部</li>
                                    <li :class="{'active': inteMatchStateText == '主队'}" data-value="2" data-key="主队">主队</li>
                                    <li :class="{'active': inteMatchStateText == '客队'}" data-value="1" data-key="客队">客队</li>
                                    <li :class="{'active': inteMatchStateText == '中立'}" data-value="3" data-key="中立">中立</li>
                                </ul>
                            </div>
                        </div>
                        <div class="type-state">
                            <span class="tab-name">情报类型</span>
                            <span class="inte-state clearfloat" ref="typestateshow" @click="showIntTypeWindow($event)" >{{inteTypeStateText}}<i class="triangle fl-r"></i></span>
                            <!-- {/* 时间切换弹窗 */} -->
                            <div :class="{'month-drop': true}" ref="intetypewindow">
                                <ul class="intestateul" ref="intetypestatelist" @click="changeInteTypeState($event)">
                                    <li :class="{'active':inteTypeStateText == '全部'}" data-value="0" data-key="全部">全部</li>
                                    <template v-if="raderTypes && raderTypes.length > 0">
                                        <li v-for="item in raderTypes" :key="item.id" :class="{'active':inteTypeStateText == item.name}" :data-value="item.id" :data-key="item.name">{{item.name}}</li>
                                    </template>
                                </ul>
                            </div>
                        </div>
                        <div class="match-state">
                            <span class="tab-name">状态</span>
                            <span class="inte-state clearfloat" ref="intestateshow" @click="showIntMatchWindow" >{{inteMatchStateText}}<i class="triangle fl-r"></i></span>
                            <!-- {/* 时间切换弹窗 */} -->
                            <div :class="{'month-drop': true}" ref="intematchwindow">
                                <ul class="intestateul" ref="intematchstatelist" @click="changeInteMatchState($event)">
                                    <li :class="{'active':inteMatchStateText == '全部'}" data-value="0" data-key="全部">全部</li>
                                    <li :class="{'active':inteMatchStateText == '已完赛'}" data-value="-1" data-key="已完赛">已完赛</li>
                                    <li :class="{'active':inteMatchStateText == '未完赛'}" data-value="1" data-key="未完赛">未完赛</li>
                                    <li :class="{'active':inteMatchStateText == '无关联'}" data-value="2" data-key="无关联">无关联</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <!-- {/* 情报模型列表 */} -->
            <div :class="{'intelligence-part': true, 'hide':false}">
                <template v-if="inteDown && !nologin && isJHApps() && behavior == 1">
                    <div class="free-inte-tips">恭喜您已获得24小时内的所有赛事情报+88元红包奖励，关注服务号，可第一时间获取最新情报哦~</div>
                </template>
                <template v-if="inteDown && !nologin">
                    <template v-if="intelligenceList && intelligenceList.length > 0">
                        <ul v-for="(item,index) in intelligenceList" :key="index" class="intelligence-list">
                            <!-- 足球 -->
                            <template v-if="item.match_type == 1">
                                <template v-for="(zq,zqIns) in MatchListNewSet(zqIntelligence)">
                                        <div v-if="zq.matchID == item.match_id" :key="zqIns" class="intelligence-detail">
                                        <!-- <i :class="{'icon':true,'i_share':true,'singleinte':true,'none':type == 20 || getAppVs() < 350 || (item.is_open == '0' && !item.title) || hiscores}" onClick={self.shareSingleInte.bind(self,item,firstcolour,firstname,zq)}></i> -->
                                        <div class="inte-info">
                                            <span :class="{'inte-circle':true,'unread':item.unread}"></span>
                                            <span class="inte-time">{{item.create_time ? item.create_time.substring(2,16).replace(/-/g,'.') : ''}}</span>
                                            <!--  eslint-disable-next-line vue/valid-v-if -->
                                            <template v-if="item.inform_type && splitInit(item.inform_type,',').length > 0">
                                                <!-- eslint-disable-next-line vue/valid-v-for -->
                                                <template v-for="(is,ins) in splitInit(item.inform_type,',')">
                                                    <span v-if="intetype_obj()[is]" :key="ins" class="inte-type" :style="{'background': intetype_obj()[is] && intetype_obj()[is].colour ? intetype_obj()[is].colour : '#7D7D7D'}">{{intetype_obj()[is].name }}</span>
                                                </template>
                                            </template>
                                        </div>
                                        <template v-if="item.is_open == '0' && !item.content">
                                            <div class="inte-content private-back">
                                                <div class="private-txt"><i class="icon i_lock"></i>开通包月即可查看所有赛事情报哦~</div>
                                                <p class="match-info clearfloat">
                                                    <span class="league fl-l">{{zq.leagueNameJ}}</span>
                                                    <span class="team">
                                                        <i class="name">{{zq.homeNameJ}}</i>
                                                        <i class="score unfinished">VS</i>
                                                        <i class="name">{{zq.awayNameJ}}</i>
                                                    </span>
                                                    <span class="time fl-r">
                                                        {{zq.matchTime ? zq.matchTime.substring(2,16).replace(/-/g,'.') : ''}}
                                                    </span>
                                                </p>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="inte-content" >
                                                <h2 class="inte-title">{{item.title}}</h2>
                                                <p class="inte-text">{{item.content}}</p>
                                                <p :class="{'inte-img':true,'nopic':!item.picture}"><img :src="item.picture" /></p>
                                                <p class="match-info clearfloat">
                                                    <span class="league fl-l">{{zq.leagueNameJ}}</span>
                                                    <span class="team">
                                                        <i class="name">{{zq.homeNameJ}}</i>
                                                        <i class="score unfinished">VS</i>
                                                        <i class="name">{{zq.awayNameJ}}</i>
                                                    </span>
                                                    <span class="time fl-r">
                                                        {{zq.matchTime ? zq.matchTime.substring(2,16).replace(/-/g,'.') : ''}}
                                                    </span>
                                                </p>
                                            </div>
                                        </template>
                                    </div>
                                </template>
                            </template>
                            <template v-else-if="item.match_type == 2">
                                <template v-for="(lq,zqIns) in MatchListNewSet(lqIntelligenceList)">
                                    <div v-if="lq.matchID == item.match_id" :key="zqIns" class="intelligence-detail">
                                        <!-- <i :class="{'icon':true,'i_share':true,'singleinte':true,'none':type == 20 || getAppVs() < 350 || (item.is_open == '0' && !item.title) || hiscores}" onClick={self.shareSingleInte.bind(self,item,firstcolour,firstname,zq)}></i> -->
                                        <div class="inte-info">
                                            <span :class="{'inte-circle':true,'unread':item.unread}"></span>
                                            <span class="inte-time">{{item.create_time ? item.create_time.substring(2,16).replace(/-/g,'.') : ''}}</span>
                                            <template v-if="item.inform_type && splitInit(item.inform_type,',').length > 0">
                                                <template v-for="(is,ins) in splitInit(item.inform_type,',')">
                                                    <span v-if="intetype_obj()[is]" :key="ins" class="inte-type" :style="{background: intetype_obj()[is].colour || '#7D7D7D'}">{{intetype_obj()[is].name }}</span>
                                                </template>

                                            </template>
                                        </div>
                                        <template v-if="item.is_open == '0' && !item.content">
                                            <div class="inte-content private-back">
                                                    <div class="private-txt"><i class="icon i_lock"></i>开通包月即可查看所有赛事情报哦~</div>
                                                    <p class="match-info clearfloat">
                                                        <span class="league fl-l">{{lq.league_name_j}}</span>
                                                        <span class="team">
                                                            <i class="name">{{lq.home_name_j}}</i>
                                                            <i class="score unfinished">VS</i>
                                                            <i class="name">{{lq.away_name_j}}</i></span>
                                                        <span class="time fl-r">
                                                            {{lq.matchTime ? lq.matchTime.substring(2,16).replace(/-/g,'.') : ''}}
                                                        </span>
                                                    </p>
                                                </div>
                                        </template>
                                        <template v-else>
                                            <div class="inte-content" @click="goMatchLiveFromInte(item)">
                                                <h2 class="inte-title">{{item.title}}</h2>
                                                <p class="inte-text">{{item.content}}</p>
                                                <p :class="{'inte-img':true,'nopic':!item.picture}"><img :src="item.picture" /></p>
                                                <p class="match-info clearfloat">
                                                    <span class="league fl-l">{{lq.league_name_j}}</span>
                                                    <span class="team">
                                                        <i class="name">{{lq.home_name_j}}</i>
                                                        <i class="score unfinished">VS</i>
                                                        <i class="name">{{lq.away_name_j}}</i></span>
                                                    <span class="time fl-r">
                                                        {{lq.matchTime ? lq.matchTime.substring(2,16).replace(/-/g,'.') : ''}}
                                                    </span>
                                                </p>
                                            </div>
                                        </template>
                                    </div>
                                </template>
                            </template>
                            <template v-else>
                                <div class="intelligence-detail">
                                    <!-- <i :class="{'icon':true,'i_share':true,'singleinte':true,'none':type == 20 || getAppVs() < 350 || (item.is_open == '0' && !item.title) || hiscores}" onClick={self.shareSingleInte.bind(self,item,firstcolour,firstname,zq)}></i> -->
                                        <div class="inte-info">
                                        <span :class="{'inte-circle':true,'unread':item.unread}"></span>
                                        <span class="inte-time">{{item.create_time ? item.create_time.substring(2,16).replace(/-/g,'.') : ''}}</span>
                                        <template v-if="item.inform_type && splitInit(item.inform_type,',').length > 0">
                                            <template v-for="(is,ins) in splitInit(item.inform_type,',')">
                                                <span v-if="intetype_obj()[is]" :key="ins" class="inte-type" :style="{background: intetype_obj()[is].colour || '#7D7D7D'}">{{intetype_obj()[is].name }}</span>
                                            </template>

                                        </template>
                                    </div>
                                    <template v-if="item.is_open == '0' && !item.content">
                                        <div class="inte-content private-back">
                                            <div class="private-txt nomatch"><i class="icon i_lock"></i>开通包月即可查看所有赛事情报哦~</div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="inte-content irrelevant" @click="openUrlInApp(item)">
                                            <h2 class="inte-title">{{item.title}}</h2>
                                            <p class="inte-text">{{item.content}}</p>
                                            <p :class="{'inte-img':true,'nopic':!item.picture}"><img :src="item.picture" /></p>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </ul>
                    </template>
                    <template v-else>
                        <ul class="intelligence-nologin">
                            <i class="daily-no-find"></i>
                            <p>暂无数据!</p>
                        </ul>
                    </template>
                </template>
                <template v-else>
                    <div class="intelligence-nologin">
                        <p class="logintxt">登录后可查看数据情报</p>
                        <p class="loginbtn" @click="gotoLogin">登录</p>
                    </div>
                </template>
            </div>
            <div class="buy-inte-rader">
                <div class="buy-btn">
                    <p @click="go_daily_buy(type, false)">{{(info.status == 1 || info.status == 2) ? '续费' : (type == 19 ? '开通即可查看全部' : '立即开通')}}</p>
                    <p class="locked">累计{{buy_info.total}}人解锁</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Down from "../../components/programme/appdown.vue"
import Header from "../../components/modelTemporary/header.vue"
import { urlQuery, setTitle, isWeiXin, getAppV, isJHApp, isHiscores, getlocalStorage, goMatchLive, isJHAppios, doLogin, isStorepack, gotourl } from "../../utils/base"
import jsbridg from '../../utils/jsbridg'
import mutil from "../../utils/mutil"
import { getDataTypeListApi, getInformLevelApi, getIntelligenceListApi, getRaderListApi } from "../../api/modelTemporary"
import { iosIsAutoPay } from "../../api/model"
// import VipEnter from "../../components/datamodel/common/vipEnter.vue"
// import { shareinit } from "../../utils/share"
// 数据模型title
var dataTitleList = {
    1: '大热',
    2: '悬殊',
    3: '同赔',
    4: '极限',
    5: '庄家态度',
    6: 'Ai智篮分析',
    15: '大数据报告',
    16: '全维预测',
    17: '指数波动',
    18: '冷门分析',
    19: '情报速递',
    20: '数据雷达',
    21: '泊松分布',
    22: '超级必发'
}
export default {
    name: "radarInformation",
    components: {
        Down,
        Header
    },
    data () {
        return {
            isScroll: true,
            isSelect: 1,
            behavior: this.$route.query.behavior || "", // 新人注册？？
            type: this.$route.query.type || 20,
            time: this.$route.query.time || "",
            info: null,
            buy_info: {
                total: 0, // 购买数据用户列表
                avatar: [] // 购买数据总人数
            },
            closeAi: false,
            raderTypes: [],
            inteMatchStateText: "全部", // 默认情报赛事状态文案
            inteTypeStateText: "全部", // 默认情报类型状态文案
            inteHomeAwayStateText: '全部', // 默认主客状态文案
            inteMatchState: "0", // 默认情报赛事状态
            inteTypeState: "0", // 默认情报类型状态
            currentPage: 1,
            pageCount: 1,
            zqIntelligence: [], // 足球情报
            lqIntelligenceList: [], // 篮球情报
            intelligenceList: [], // 情报列表
            intelligenceType: [], // 情报类型列表
            inteRecommendTotal: 0, // 情报推荐总数
            inteRecommendTime: "", // 情报推荐更新时间
            inteDown: 0, // 情报接口是否加载完毕
            moreinte_lock: false,
            showintematch: false, // 情报赛事状态弹窗
            showintetype: false, // 情报类型状态弹窗
            nologin: false,
            hiscores: 0,
            showHomeAway: false,
            inteRecommendTotalCurrent: 0
        }
    },
    created () {
        this.iosIsAutoPay()
        this.getDataTypeList()
        this.$nextTick(() => {
            window.addEventListener("scroll", this.listScroll, true)
            // eslint-disable-next-line eqeqeq
            var getLastRaderIds = getlocalStorage(this.type == "20" ? "lastRaderIds" : "lastIntelligenceIds") || "";
            if (getLastRaderIds) {
                var raderIdArr = JSON.parse(getLastRaderIds);
                this.raderlistids = raderIdArr
            }
        })
        // 嗨比分
        if (isHiscores()) {
            this.hiscores = 1
        }
    },
    methods: {
        gotoLogin () {
            doLogin();
        },
        go_daily_buy (type, renewals) {
            var iosNeedLogin = this.$route.query.ios_need_login * 1 || 0;
            if ((isJHAppios() && getAppV() >= 342) || (this.hiscores && !iosNeedLogin)) {
                // ios V>=342
                // hiscores 不强制登录
            } else {
                if (this.nologin) {
                    doLogin();
                    return;
                }
            }
            // ios商城包自动续费已开通
            if (this.onlineIsAuto && !isStorepack()) {
                // window.swal({
                //     type: "alert",
                //     title: "温馨提示",
                //     confirmTitle: "我知道了",
                //     detail: "您已开通了自动续费功能，需要到苹果设备上取消续费后才能再次购买哦~ 取消方法：通过手机【设置】进入【iTunes Store与App Store】>>选择【Apple ID】>>点击【查看Apple ID】>>在账户设置页面点击【订阅管理】>>取消即嗨" + (dataTitleList[type]) + "数据的订阅即可。"
                // })
                return;
            }
            let url = ""
            if (isJHAppios() || !isJHApp()) {
                url = process.env.VUE_APP_H5_DOMAIN + '/page/new_pay?ordertype=pay_data&type=' + type;
            } else {
                url = process.env.VUE_APP_DOMAIN + '/user/payment?type=' + type;
            }
            if (renewals) {
                url += "&renewals=1"
            }
            gotourl(url);
        },
        // 检查ios商城包是否自动续费
        async iosIsAutoPay () {
            const type = urlQuery("type") || 1;
            const data = await iosIsAutoPay(type)
            // eslint-disable-next-line eqeqeq
            if (data.errno * 1 == 0) {
                this.onlineIsAuto = false
            // eslint-disable-next-line eqeqeq
            } else if (data.errno * 1 == 282) {
                this.onlineIsAuto = true
            // eslint-disable-next-line eqeqeq
            } else if (data.errno * 1 == -1) {
                this.nologin = true
            }
        },
        changeInteHomeAway (e) {
            var self = this;
            var inteHomeAwaywindow = self.$refs.inteHomeAwaywindow;
            var target = e.target || e.srcElement;
            var value = target.getAttribute('data-value');
            var key = target.getAttribute('data-key');
            // 状态未变不刷新
            // eslint-disable-next-line eqeqeq
            if (this.inteHomeAwayState == value) {
                this.showintetype = false
                inteHomeAwaywindow.style.display = "none";
                return;
            }
            var inteHomeAwaylist = self.$refs.inteHomeAwaylist.childNodes;
            inteHomeAwaylist.forEach(el => {
                el.setAttribute('class', "");
            })
            target.setAttribute('class', "active");
            this.isScroll = true;
            this.currentPage = 1
            this.pageCount = 1
            this.inteMatchState = this.inteMatchState
            this.inteTypeState = this.inteTypeState
            this.inteHomeAwayState = value
            this.inteHomeAwayStateText = key
            this.showintetype = false
            this.moreinte_lock = false
            // 切换时刷新情报列表
            inteHomeAwaywindow.style.display = "none";
            // eslint-disable-next-line eqeqeq
            self.getRaderList();
        },
        showIntHomeAwayWindow () {
            // 情报类型弹窗
            var self = this;
            var inteHomeAwaywindow = self.$refs.inteHomeAwaywindow;
            this.showHomeAway = !this.showHomeAway
            if (self.showHomeAway) {
                inteHomeAwaywindow.style.display = "block";
            } else {
                inteHomeAwaywindow.style.display = "none";
            }
            var intetypewindow = self.$refs.intetypewindow;
            intetypewindow.style.display = 'none'
            var intematchwindow = self.$refs.intematchwindow;
            intematchwindow.style.display = 'none'
        },
        changeInteTypeState (e) {
            var intetypewindow = this.$refs.intetypewindow;
            var target = e.target || e.srcElement;
            var value = target.getAttribute('data-value');
            var key = target.getAttribute('data-key');
            // 状态未变不刷新
            // eslint-disable-next-line eqeqeq
            if (this.inteTypeState == value) {
                this.showintetype = false
                intetypewindow.style.display = "none";
                return;
            }
            var intetypestates = this.$refs.intetypestatelist.childNodes;
            intetypestates.forEach(el => {
                el.setAttribute('class', "");
            })
            target.setAttribute('class', "active");
            this.isScroll = true;
            this.currentPage = 1
            this.pageCount = 1
            this.inteMatchState = this.inteMatchState
            this.inteTypeState = value
            this.inteTypeStateText = key
            this.showintetype = false
            this.moreinte_lock = false
            // 切换时刷新情报列表
            intetypewindow.style.display = "none";
            // eslint-disable-next-line eqeqeq
            this.getRaderList();
        },
        // 情报模型-切换状态
        changeInteMatchState (e) {
            var intematchwindow = this.$refs.intematchwindow;
            var target = e.target || e.srcElement;
            var value = target.getAttribute('data-value');
            var key = target.getAttribute('data-key');
            // 状态未变不刷新
            // eslint-disable-next-line eqeqeq
            if (this.inteMatchState == value) {
                this.showintematch = false
                intematchwindow.style.display = "none";
                return;
            }
            var intematchstates = this.$refs.intematchstatelist.childNodes;
            intematchstates.forEach(el => {
                el.setAttribute('class', "");
            })
            target.setAttribute('class', "active");
            this.isScroll = true;
            this.currentPage = 1
            this.pageCount = 1
            this.inteMatchState = value
            this.inteTypeState = this.inteTypeState
            this.inteMatchStateText = key
            this.showintematch = false
            this.moreinte_lock = false
            // 切换时刷新情报列表
            intematchwindow.style.display = "none";
            // eslint-disable-next-line eqeqeq
            this.getRaderList();
        },
        // 更多情报分页
        moreIntelligence () {
            // 最后一页
            // eslint-disable-next-line eqeqeq
            if (this.currentPage == this.pageCount * 1) {
                this.isScroll = false;
                return;
            }
            // eslint-disable-next-line eqeqeq
            if (this.pageCount * 1 == 0) {
                this.isScroll = false;
                return;
            }
            var nextPage = this.currentPage * 1 + 1;
            if (nextPage >= this.pageCount * 1) {
                nextPage = this.pageCount;
            }
            this.currentPage = nextPage
            this.getRaderList();
        },
        // 分页条件
        needScrollLoad () {
            if (this.moreinte_lock) {
                return;
            }
            var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            var clientHeight = window.innerHeight;
            return (clientHeight + scrollTop) - scrollHeight >= -10
        },
        // 分页
        listScroll (e) {
            if (!this.isScroll) {
                return;
            }
            if (this.needScrollLoad()) {
                this.moreinte_lock = true
                this.moreIntelligence();
            }
        },
        isJHApps () {
            return isJHApp()
        },
        // 跳转赛事详情页
        goMatchLiveFromInte (item) {
            var matchid = item.match_id;
            // 足球
            // eslint-disable-next-line eqeqeq
            if (item.match_type == 1) {
                goMatchLive(matchid);
            } else {
                // 篮球
                goMatchLive(matchid, 'lq');
            }
        },
        openUrlInApp (item) {
            let json = {};
            // eslint-disable-next-line eqeqeq
            if (item.jump_type == "3") {
                // 浏览器
                json = {
                    url: item.jump_url,
                    jumptype: 3
                }
                // eslint-disable-next-line eqeqeq
            } else if (item.jump_type == "2") {
                // 客户端webview
                json = {
                    url: item.jump_url,
                    jumptype: 2
                }
                // eslint-disable-next-line eqeqeq
            } else if (item.jump_type == "1") {
                // 客户端原生
                json = {
                    code: item.jump_url,
                    params: item.jump_params,
                    jumptype: 1
                }
            }
            jsbridg.goWebview(json);
        },
        intetype_obj () {
            // eslint-disable-next-line camelcase
            var intetype_obj = {};
            if (this.intelligenceType && this.intelligenceType.length > 0) {
                this.intelligenceType.forEach(intetype => {
                    // eslint-disable-next-line camelcase
                    var intetype_id = intetype.id;
                    // eslint-disable-next-line camelcase
                    var intetype_name = intetype.name;
                    // eslint-disable-next-line camelcase
                    var intetype_color = intetype.colour;
                    intetype_obj[intetype_id] = {
                        name: intetype_name,
                        colour: intetype_color
                    }
                })
            }
            // eslint-disable-next-line camelcase
            return intetype_obj
        },
        splitInit (item, type) {
            return item.split(type)
        },
        getAppVs () {
            return getAppV()
        },
        // 足球篮球去重
        MatchListNewSet (item, type) {
            // debugger
            var OriginIds = [];// 足球ids
            var MatchList = [];// 去重足球list
            if (item && item.length > 0) {
                item.forEach(zqitem => {
                    if (OriginIds.indexOf(zqitem.matchID) > -1) {
                        // 重复不予添加到list
                    } else {
                        MatchList.push(zqitem);
                    }
                    OriginIds.push(zqitem.matchID);
                });
            }
            // eslint-disable-next-line eqeqeq
            if (type == 'id') {
                return OriginIds
            } else {
                return MatchList
            }
        },
        // 情报模型-显示或隐藏状态弹窗
        showIntTypeWindow () {
            // 情报类型弹窗
            var intetypewindow = this.$refs.intetypewindow;
            this.showintetype = !this.showintetype
            if (this.showintetype) {
                intetypewindow.style.display = "block";
            } else {
                intetypewindow.style.display = "none";
            }
        },
        showIntMatchWindow () {
            var intematchwindow = this.$refs.intematchwindow;
            this.showintematch = !this.showintematch
            if (this.showintematch) {
                intematchwindow.style.display = "block";
            } else {
                intematchwindow.style.display = "none";
            }
        },
        // 获取雷达列表
        async getRaderList () {
            const type = this.type;
            const params = {
                type: type,
                match_state: this.inteMatchState || "",
                inform_type: this.inteTypeState || "",
                team: this.inteHomeAwayState,
                page: this.currentPage
            }
            let data = {}
            // eslint-disable-next-line eqeqeq
            if (type == 19) {
                data = await getIntelligenceListApi(params)
            } else {
                data = await getRaderListApi(params)
            }
            // eslint-disable-next-line eqeqeq
            if (data && data.errno == '0') {
                var intedata = data.data;
                // eslint-disable-next-line eqeqeq
                if (this.currentPage == 1) {
                    this.zqIntelligence = intedata.zq_match || []
                    this.lqIntelligenceList = intedata.lq_match || []
                    this.intelligenceType = intedata.information_type || []
                    this.intelligenceList = intedata.record || []
                    this.inteRecommendTotal = intedata.all_total || 0
                    this.inteRecommendTime = intedata.happened
                    this.currentPage = intedata.cur_page * 1
                    this.pageCount = intedata.page_count * 1
                    this.inteDown = 1
                    // eslint-disable-next-line eqeqeq
                    if (this.inteMatchState == 0 && this.inteTypeState == 0 && this.inteHomeAwayState == -1) {
                        this.inteRecommendTotalCurrent = intedata.total || 0
                    }
                } else {
                    this.zqIntelligence = this.zqIntelligence.concat(intedata.zq_match)
                    this.lqIntelligenceList = this.lqIntelligenceList.concat(intedata.lq_match)
                    this.intelligenceType = intedata.information_type
                    this.intelligenceList = this.intelligenceList.concat(intedata.record)
                    this.currentPage = intedata.cur_page * 1
                    this.pageCount = intedata.page_count * 1
                    this.inteDown = 1
                    this.moreinte_lock = false
                }
            }
        },
        // 获取雷达类型列表
        async getInformLevel () {
            const type = this.type;
            var informModel = 2;
            // eslint-disable-next-line eqeqeq
            if (type == 19) {
                informModel = 1;
            }
            const data = await getInformLevelApi({ inform_model: informModel })
            // eslint-disable-next-line eqeqeq
            if (data && data.errno == '0') {
                this.raderTypes = data.data
                // eslint-disable-next-line eqeqeq
                this.getRaderList();
            }
        },
        isWeixins () {
            return isWeiXin()
        },
        // 数据列表页
        async getDataTypeList (year, month, day, tab, cold) {
            const jsons = {};
            const type = this.type;
            let time = urlQuery("time") || "";
            jsons.type = type;
            // eslint-disable-next-line eqeqeq
            jsons.tab = tab || "r";
            if (year && month && day) {
                if (day < 10) {
                    day = "0" + day;
                }
                if (month < 10) {
                    month = "0" + month;
                }
                time = year + "-" + month + "-" + day;
            }
            if (time) {
                jsons.time = time;
            }
            setTitle(mutil.dailyMap[type + '']);
            const data = await getDataTypeListApi(jsons)
            // eslint-disable-next-line eqeqeq
            if (data && data.errno == '0') {
                this.buy_info = {
                    total: data.buy_info.total,
                    avatar: data.buy_info.avatar
                }
                this.info = data.info
                this.loading = false
                this.getInformLevel();
                const linkUrl = document.URL + "&invite_id=" + data.invite_id;
                var desc = "最高预测命中率达91%！来“即嗨”，看赛事数据！";
                // eslint-disable-next-line eqeqeq
                if (type == 20) {
                    desc = '全网最快一手数据！来“即嗨”看赛事数据！';
                }
                var shareobj = {
                    title: '即嗨正当红大数据模型！——' + (dataTitleList[type]) + '，当前已有' + (this.buy_info && this.buy_info.total) + '人订阅',
                    desc: desc,
                    link: linkUrl,
                    imgUrl: "https://s.jihaimall.com/h5/image/jhtylogo.png"
                }
                // shareType 1表示邀请好友的分享，2表示可以分享到小程序
                // eslint-disable-next-line eqeqeq
                if (type == 19 && !this.hiscores) {
                    shareobj.wechatMiniId = "gh_daa6378f14c9";
                    shareobj.path = "pages/newspush/newspush";
                    shareobj.shareType = 2;
                    // shareinit(shareobj);
                }
            }
        }
    }
}
</script>

<style>
@import url("../../assets/css/_discovery.min.css");
</style>
